import { IActiveCoupon } from './coupon';

export type IApiGetDemoDataParam = any;

export type IGetCustomersParam = {
  page?: number;
  size?: number;
  lastPhoneNumber?: number | string;
  pointFrom?: number | string;
  pointTo?: number | string;
  sendingAmountFrom?: number | string;
  sendingAmountTo?: number | string;
  types?: string;
};

export type IResCustomers = {
  content: ICustomer[];
  totalElements: number;
};

export interface ICustomer {
  id: string;
  name: string;
  phone: string;
  email: string;
  point: number;
  birthday: string;
  note: string;
  createdDate: string;
  status: string;
  numberVisit: number;
  imageAvatarUrl: string | null;
  amountSpent: number | null;
  lastVisitedDate: string | null;
  accountPackage: IAccountPackage;
  totalEarnPoint: number;
  street: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  linkReferral: string;
  referralSender: string | null;
  hobbies: string | null;
  color: string | null;
  health: string | null;
}

export enum IAccountPackage {
  NEW = 'NEW',
  VIP = 'VIP',
  REGULAR = 'REGULAR',
}

export interface IReferralsParams {
  customerId?: string;
  page?: number;
  size?: number;
  couponType?: string;
}

export type IResTransactions = {
  content: any[];
  totalElements: number;
};

export interface IResSummaryReport {
  amountSpend: number;
  point: number;
  totalUsedCoupon: number;
  totalAppointment: number;
  totalWalkIn: number;
}

export interface ICouponsParams {
  customerId?: string;
  page?: number;
  size?: number;
}
export interface IActiveCouponsParams {
  customerId?: string;
  page?: number;
  size?: number;
}

export type IResActiveCoupons = {
  content: IActiveCoupon[];
  totalElements: number;
};